module.exports = __webpack_public_path__ + "media/images/navbar/burger-d3a3f51bf5f7f91fba23a7b8879f1cd5.svg";